/**
 * @generated SignedSource<<922c292bff06370043898ba5f31d4cc6>>
 * @relayHash 5b5900af74febfaa4c38e8a87d66f1ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e337f9a844dc439e68d0e4f4034d804d0b86dd187da4d8a42b5c6182bf329cce

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBackgroundType = "ATTACHMENT" | "COLOR" | "CUSTOM" | "GRADIENT" | "UNSPLASH" | "%future added value";
export type DominantColorPersisterMutation$variables = {
  backgroundType: JiraBackgroundType;
  backgroundValue: string;
  dominantColor?: string | null;
  entityId: string;
};
export type DominantColorPersisterMutation$data = {
  readonly jira_updateProjectBackground: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly project: {
      readonly background: {
        readonly " $fragmentSpreads": FragmentRefs<"ThemeSetterBackground">;
      } | null;
    } | null;
    readonly success: boolean;
  } | null;
};
export type DominantColorPersisterMutation = {
  response: DominantColorPersisterMutation$data;
  variables: DominantColorPersisterMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "backgroundType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "backgroundValue"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dominantColor"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityId"
},
v4 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "backgroundType",
        "variableName": "backgroundType"
      },
      {
        "kind": "Variable",
        "name": "backgroundValue",
        "variableName": "backgroundValue"
      },
      {
        "kind": "Variable",
        "name": "dominantColor",
        "variableName": "dominantColor"
      },
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "entityId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "success"
},
v6 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DominantColorPersisterMutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraProjectUpdateBackgroundMutationPayload",
        "kind": "LinkedField",
        "name": "jira_updateProjectBackground",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "background",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "ThemeSetterBackground"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "DominantColorPersisterMutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraProjectUpdateBackgroundMutationPayload",
        "kind": "LinkedField",
        "name": "jira_updateProjectBackground",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "background",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "colorValue"
                      }
                    ],
                    "type": "JiraColorBackground"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "gradientValue"
                      }
                    ],
                    "type": "JiraGradientBackground"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraCustomBackground",
                        "kind": "LinkedField",
                        "name": "customBackground",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "mediaApiFileId"
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "durationInSeconds",
                                "value": 900
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "mediaReadToken",
                            "storageKey": "mediaReadToken(durationInSeconds:900)"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "sourceType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "sourceIdentifier"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "altText"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "dominantColor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "brightness"
                          }
                        ]
                      }
                    ],
                    "type": "JiraMediaBackground"
                  }
                ]
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e337f9a844dc439e68d0e4f4034d804d0b86dd187da4d8a42b5c6182bf329cce",
    "metadata": {},
    "name": "DominantColorPersisterMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "43258b1a684094bbd26b433d985eb573";

export default node;
